import { render, staticRenderFns } from "./LabElementEdit.vue?vue&type=template&id=050ddf0e"
import script from "./LabElementEdit.vue?vue&type=script&lang=js"
export * from "./LabElementEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('050ddf0e')) {
      api.createRecord('050ddf0e', component.options)
    } else {
      api.reload('050ddf0e', component.options)
    }
    module.hot.accept("./LabElementEdit.vue?vue&type=template&id=050ddf0e", function () {
      api.rerender('050ddf0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/labElement/LabElementEdit.vue"
export default component.exports